var _filter, _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgS111Ele(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1000,
    viewBox: "0 0 1000 1000",
    width: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 338.139,
    width: 1067.81,
    x: -34.3058,
    y: 709.493
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.6781
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 39.1529
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.494118 0 0 0 0 0.694118 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2747_159972"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2747_159972",
    mode: "normal",
    result: "shape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1000v1000h-1000z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fae9f2",
    height: 181.527,
    rx: 72.9668,
    width: 911.195,
    x: 44,
    y: 777.121
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ea0d8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.3295 819.233c-7.2014.139-12.3668-4.499-12.5043-11.603-.0949-4.905 1.4338-10.518 6.1376-21.269l5.9543-13.821c.4713-1.024 1.4403-1.72 2.5859-1.742l8.0198-.155c1.473-.029 2.311.97 1.8495 2.502l-7.0869 22.98c4.2914 1.778 7.1524 5.784 7.2506 10.858.1342 6.935-4.8414 12.107-12.2065 12.25zm31.2608-.605c-7.2014.139-12.3668-4.499-12.5043-11.603-.0949-4.905 1.4337-10.518 6.1376-21.269l5.9542-13.821c.4714-1.024 1.4403-1.72 2.586-1.742l8.0202-.155c1.473-.029 2.311.97 1.849 2.502l-7.087 22.98c4.292 1.778 7.153 5.784 7.251 10.858.134 6.935-4.842 12.107-12.2067 12.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m933.695 930.469c7.201-.139 12.366 4.499 12.504 11.603.095 4.905-1.434 10.518-6.138 21.269l-5.954 13.821c-.471 1.024-1.44 1.72-2.586 1.742l-8.02.155c-1.473.029-2.311-.97-1.849-2.502l7.087-22.98c-4.292-1.778-7.153-5.784-7.251-10.858-.134-6.935 4.842-12.107 12.207-12.25zm-31.261.605c7.201-.139 12.367 4.499 12.504 11.603.095 4.905-1.434 10.518-6.137 21.269l-5.955 13.821c-.471 1.024-1.44 1.72-2.586 1.742l-8.019.155c-1.473.029-2.311-.97-1.85-2.502l7.087-22.98c-4.291-1.778-7.152-5.784-7.251-10.858-.134-6.935 4.842-12.107 12.207-12.25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS111Ele);
export default __webpack_public_path__ + "static/media/S1_1_1_ELE.275f831e2a4b7763cafa5f41d76aa01f.svg";
export { ForwardRef as ReactComponent };